import { Component, Input } from "@angular/core";
import { SvgIcon, SvgIconMap } from "@ponder-shared/utils/svgIcons";
import { PreviewItemComponent } from "../preview-item.component";

@Component({
    selector: "preview-item-context-proxy",
    imports: [],
    templateUrl: "./preview-item-context-menu-proxy.component.html"
})
export class PreviewItemContextMenuProxy {
    @Input({ required: true }) previewItem!: PreviewItemComponent;
    
    public readonly svgIcon: string = SvgIconMap.get(SvgIcon.Proxy)!;

    public getCount(): number {
        return this.previewItem.previewItem.collected?.proxyCount ?? 0;
    }
    
    public onIncrement(): void {
        this.previewItem.adjustCount(0, 0, 1);
    }

    public onDecrement(): void {
        this.previewItem.adjustCount(0, 0, -1);
    }

    public onChange(event: Event): void {
        var target = (event.target as HTMLInputElement);
        this.previewItem.setProxyCount(Number.parseInt(target.value));
        target.value = `${this.getCount()}`;
    }
}